export default {
      id: "i-fb-usage",
      viewBox: "0 0 10 17",
      url: __webpack_public_path__ + "img/sprite.svg#i-fb",
      toString: function () {
        return this.url;
      }
    }